import React from "react";
import { object } from "prop-types";

import { getCollectionTemplate } from "../get-collection-template";
import { LazyCollection } from "@quintype/components";
import HeaderWrapper from "../header/header-wrapper";

import "./home.m.css";

export const HomePage = ({ data }) => {
  return (
    <div styleName="home-wrapper">
      <HeaderWrapper />
      <div styleName="collection-container">
        {data.collection && (
          <LazyCollection
            liveBlogStory={data.liveBlogStory}
            collection={data.collection}
            collectionTemplates={getCollectionTemplate}
            lazyAfter={10}
          />
        )}
      </div>
    </div>
  );
};

HomePage.propTypes = {
  data: object
};
